import { Editor, Range, Transforms } from 'slate';
import { CustomEditor } from 'components/text-editor/hooks/use-custom-editor/index';

export type DeleteAnnotation = (props: string[], annotationId: string) => void;

/**
 * The deleteAnnotation function does not actually delete anything - rather, it removes
 * custom properties from it block elements (and only block elements!).
 * If there are no more custom properties, it converts the element type to "paragraph",
 * which is the default.
 */

export default function deleteAnnotation(
  editor: CustomEditor,
): DeleteAnnotation {
  return function (props: string[], annotationId: string) {
    const at = editor.getSlateRangeByAnnotationId(annotationId);

    if (at) {
      Transforms.select(editor, at);
    }

    props.forEach((key) => {
      Editor.removeMark(editor, key);
    });

    if (at) {
      Transforms.deselect(editor);
    }
  };
}
